// extracted by mini-css-extract-plugin
export default {"root":"DisplayReportsSkeleton_root__+Of2v","spacing":"DisplayReportsSkeleton_spacing__xPdy+"};